import { configureStore } from '@reduxjs/toolkit';
import globalReducer from './state-slices/globalSlice';

export default configureStore({
  reducer: {
    global: globalReducer,
  }
});